import { FC, useMemo } from 'react';
import { FInter, FlexBox } from '@brg/ui';
import { SendProjectButton } from '../../_competition/components/SendProjectButton';
import styled from 'styled-components';
import {LayoutConst} from "../../core";
import { useTranslation } from 'react-i18next';
import useCompetitionActions from 'shared/hooks/useCompetitionActions';
import { Competition } from '@brg/api';

const Title = styled(FInter.SectionTitleFlex)`
    color: ${({theme}) => theme.competition.frameMainText};
    justify-content: center;
    text-align: center;
    font-size: 30px;
    line-height: 40px;
    font-weight: 600;

    @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
        font-size: 23px;
        line-height: 29px;
    }

    @media(max-width: ${LayoutConst.screen.s}px) {
        font-size: 20px;
        line-height: 25px;
    }
`;

const Description = styled(FInter.TextFlex)`
    color: ${({theme}) => theme.competition.frameMainText};
    justify-content: center;
    text-align: center;
    font-size: 17px;
    line-height: 22px;
    margin-top: 16px;
    max-width: 815px;

    @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
        font-size: 15px;
        line-height: 20px;
    }

    @media(max-width: ${LayoutConst.screen.m}px) {
        max-width: 285px;
    }

    @media(max-width: ${LayoutConst.screen.s}px) {
    }
`;

const ButtonsWrapper = styled(FlexBox)`
    gap: 16px;
`

export const CompetitionBravoModal: FC<{onClick: () => void, someNominations?: boolean, isShareModal?: boolean, isExam?: boolean, competition?: Competition, onBackToCompetition?: () => void, isPaidApplication?: boolean}> = ({competition, isExam, isShareModal, someNominations, onClick, onBackToCompetition, isPaidApplication}) => {

    const {t, i18n: {language}} = useTranslation()

    const { 
        isPromptCompetition,
      } = useCompetitionActions(competition);

      const title = useMemo(() => {
        if (isPaidApplication) {
            return <span>{t('competitions_send_modal.title.title_paid')}</span>
        }
        if (isPromptCompetition) {
            return <span>{t('competitions_send_modal.title.title_prompt')}</span>
        }
        if (isExam) {
            return <span>{t('competitions_send_modal.title.title_exam')}</span>
        }
        return (
            <span>
                    {t('competitions_send_modal.project_submitted')} 
                    {language === 'ru' ? <br/> : ''} 
                    {language === 'ru' ? `на участие в конкурс${someNominations? 'ах' : "е"}` : ''}
            </span>
        )
      } , [t, someNominations, language])

      const description = useMemo(() => {
        if (isPaidApplication) {
            return <span>{t('competitions_send_modal.description.desc_paid')}</span>
        }
        if (isPromptCompetition) {
            return <span>{t('competitions_send_modal.description.title_prompt')}</span>
        }
        if (isExam) {
            return <span>{t('competitions_send_modal.description.title_exam')}</span>
        }

        return t('competitions_send_modal.main')
      } , [t, language])

    return <div>
        <FlexBox justify={'center'} direction='column' directionMobile='column'>
            <Title>
                {title}
            </Title>
            <Description>
                {description}
            </Description>
            {
            isPaidApplication?
                <ButtonsWrapper justify={'center'} offsetTop={40}>
                    <SendProjectButton width={283} onClick={onClick}>
                        {t('competitions_send_modal.to_materials_button')}
                    </SendProjectButton>
                    <SendProjectButton width={283} onClick={() => onBackToCompetition && onBackToCompetition()}>
                        {t('competitions_send_modal.to_contest_button')}
                    </SendProjectButton>
                </ButtonsWrapper>
                :
                <ButtonsWrapper justify={'center'} offsetTop={40}>
                    <SendProjectButton width={283} onClick={onClick}>
                        {isExam ? 'На страницу модуля' : isShareModal ? 'На главную' : t('competitions_send_modal.to_contest_button')}
                    </SendProjectButton>
                </ButtonsWrapper>}
        </FlexBox>
    </div>

};
import { FC, useMemo } from 'react';
import { FInter, FlexBox } from '@brg/ui';
import { SendProjectButton } from '../../_competition/components/SendProjectButton';
import styled from 'styled-components';
import {LayoutConst} from "../../core";
import { useTranslation } from 'react-i18next';
import useCompetitionActions from 'shared/hooks/useCompetitionActions';
import { Competition } from '@brg/api';

const Title = styled(FInter.SectionTitleFlex)`
    color: ${({theme}) => theme.competition.frameMainText};
    justify-content: center;
    text-align: center;
    font-size: 30px;
    line-height: 40px;
    font-weight: 600;

    @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
        font-size: 23px;
        line-height: 29px;
    }

    @media(max-width: ${LayoutConst.screen.s}px) {
        font-size: 20px;
        line-height: 25px;
    }
`;

const Description = styled(FInter.TextFlex)`
    color: ${({theme}) => theme.competition.frameMainText};
    justify-content: center;
    text-align: center;
    font-size: 17px;
    line-height: 22px;
    margin-top: 16px;
    max-width: 815px;

    @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
        font-size: 15px;
        line-height: 20px;
    }

    @media(max-width: ${LayoutConst.screen.m}px) {
        max-width: 285px;
    }

    @media(max-width: ${LayoutConst.screen.s}px) {
    }
`;

const ButtonsWrapper = styled(FlexBox)`
    gap: 16px;
`

export const CompetitionBravoModal: FC<{onClick: () => void, someNominations?: boolean, isShareModal?: boolean, isExam?: boolean, competition?: Competition, onBackToCompetition?: () => void, isPaidApplication?: boolean}> = ({competition, isExam, isShareModal, someNominations, onClick, onBackToCompetition, isPaidApplication}) => {

    const {t, i18n: {language}} = useTranslation()

    const { 
        isPromptCompetition,
      } = useCompetitionActions(competition);

      const title = useMemo(() => {
        if (isPaidApplication) {
            return <span>{t('competitions_send_modal.title.title_paid')}</span>
        }
        if (isPromptCompetition) {
            return <span>{t('competitions_send_modal.title.title_prompt')}</span>
        }
        if (isExam) {
            return <span>{t('competitions_send_modal.title.title_exam')}</span>
        }
        return (
            <span>
                    {t('competitions_send_modal.project_submitted')} 
                    {language === 'ru' ? <br/> : ''} 
                    {language === 'ru' ? `на участие в конкурс${someNominations? 'ах' : "е"}` : ''}
            </span>
        )
      } , [t, someNominations, language])

      const description = useMemo(() => {
        if (isPaidApplication) {
            return <span>{t('competitions_send_modal.description.desc_paid')}</span>
        }
        if (isPromptCompetition) {
            return <span>{t('competitions_send_modal.description.title_prompt')}</span>
        }
        if (isExam) {
            return <span>{t('competitions_send_modal.description.title_exam')}</span>
        }

        return t('competitions_send_modal.main')
      } , [t, language])

    return <div>
        <FlexBox justify={'center'} direction='column' directionMobile='column'>
            <Title>
                {title}
            </Title>
            <Description>
                {description}
            </Description>
            {
            isPaidApplication?
                <ButtonsWrapper justify={'center'} offsetTop={40}>
                    <SendProjectButton width={283} onClick={onClick}>
                        {t('competitions_send_modal.to_materials_button')}
                    </SendProjectButton>
                    <SendProjectButton width={283} onClick={() => onBackToCompetition && onBackToCompetition()}>
                        {t('competitions_send_modal.to_contest_button')}
                    </SendProjectButton>
                </ButtonsWrapper>
                :
                <ButtonsWrapper justify={'center'} offsetTop={40}>
                    <SendProjectButton width={283} onClick={onClick}>
                        {isExam ? 'На страницу модуля' : isShareModal ? 'На главную' : t('competitions_send_modal.to_contest_button')}
                    </SendProjectButton>
                </ButtonsWrapper>}
        </FlexBox>
    </div>

};
